/**
 * Shared response parsing for PUT section_mapping (Brazil page mapping submit).
 */
import { SectionMappingSaveResult } from '../components/Common/SectionMapping/types';
import { resolveSimpleSaveResponse } from './resolveSimpleSaveResponse';

// eslint-disable-next-line import/prefer-default-export
export const resolveSectionMappingSaveResponse = (response: any): SectionMappingSaveResult =>
  resolveSimpleSaveResponse(response, 'Saved successfully', 'Failed to save section mapping');
